export default "__VITE_ASSET__D1$Kon3l__"